import {InlineDataComponentRegistry} from '@stripe-internal/inline-data';

import {EmailVerification} from './EmailVerification';
import {ProgrammableThermostatSample} from './ProgrammableThermostatSample';
import {MerchantIssueSummary} from './MerchantIssueSummary';
import {MerchantVerificationStatus} from './MerchantVerificationStatus';
import {MerchantPayoutStatus} from './MerchantPayoutStatus';
import {UniversalHelpLiveAnswersResponse} from './UniversalHelpLiveAnswersResponse';
import {MerchantVerificationAffectingPayouts} from './MerchantVerificationAffectingPayouts';
import {UniversalHelpChannelMenu} from './UniversalHelpChannelMenu';
import {UniversalHelpSignInPrompt} from './UniversalHelpSignInPrompt';
import {UpdateBankAccount} from './UpdateBankAccount';
import {ExpressDeleteAccount} from './ExpressDeleteAccount';
import {MerchantFollowUpCase} from './MerchantFollowUpCase';
import {LinkDeclines} from './LinkDeclines';
import {ConnectedAccountChooser} from './ConnectedAccountChooser';
import {TaxForm1099PreviousYear} from './TaxForm1099PreviousYear';
import {TaxForm1099CurrentYear} from './TaxForm1099CurrentYear';
import {ContactSalesForm} from './ContactSalesForm';
import {IdealInquiryForm} from './IdealInquiryForm';
import {LinkTransactionCard} from './LinkTransactionCard';
import {RiskReviewForm} from './Risk/RiskReviewForm';
import {UrlIntervention} from './Risk/UrlIntervention';
import {ChargeLookupForm} from './ChargeLookupForm';
import {BusinessCard} from './BusinessCard';
import {MerchantFollowUpCaseOptions} from './MerchantFollowUpCaseOptions';
import {EmailInputForm} from './EmailInputForm';
import {OtpInputForm} from './OtpInputForm';
import {LinkAccountDetails} from './LinkAccountDetails';
import {RequestAReview} from './RequestAReview';

export const DefaultInlineDataComponentRegistry: InlineDataComponentRegistry = {
  'mse-inline-data:ContactSalesChatForm': ContactSalesForm,
  'mse-inline-data:ContactSalesEmailForm': ContactSalesForm,
  'mse-inline-data:EmailVerification': EmailVerification,
  'mse-inline-data:ProgrammableThermostat': ProgrammableThermostatSample,
  'mse-inline-data:MerchantIssueSummary': MerchantIssueSummary,
  'mse-inline-data:MerchantVerificationStatus': MerchantVerificationStatus,
  'mse-inline-data:UniversalHelpChannelMenu': UniversalHelpChannelMenu,
  'mse-inline-data:LiveAnswersResponse': UniversalHelpLiveAnswersResponse,
  'mse-inline-data:MerchantPayoutStatus': MerchantPayoutStatus,
  'mse-inline-data:MerchantVerificationAffectingPayouts':
    MerchantVerificationAffectingPayouts,
  'mse-inline-data:UniversalHelpSignInPrompt': UniversalHelpSignInPrompt,
  'mse-inline-data:UpdateBankAccount': UpdateBankAccount,
  'mse-inline-data:ExpressDeleteAccount': ExpressDeleteAccount,
  'mse-inline-data:MerchantFollowUpCase': MerchantFollowUpCase,
  'mse-inline-data:LinkDeclines': LinkDeclines,
  'mse-inline-data:ConnectedAccountChooser': ConnectedAccountChooser,
  'mse-inline-data:TaxForm1099CurrentYear': TaxForm1099CurrentYear,
  'mse-inline-data:TaxForm1099PreviousYear': TaxForm1099PreviousYear,
  'mse-inline-data:LinkTransactionCard': LinkTransactionCard,
  'mse-inline-data:IdealInquiryForm': IdealInquiryForm,
  'mse-inline-data:RiskUrlIntervention': UrlIntervention,
  'mse-inline-data:RiskReviewForm': RiskReviewForm,
  'mse-inline-data:ChargeLookupForm': ChargeLookupForm,
  'mse-inline-data:BusinessCard': BusinessCard,
  'mse-inline-data:MerchantFollowUpCaseOptions': MerchantFollowUpCaseOptions,
  'mse-inline-data:EmailInputForm': EmailInputForm,
  'mse-inline-data:OtpInputForm': OtpInputForm,
  'mse-inline-data:LinkAccountDetails': LinkAccountDetails,
  'mse-inline-data:RequestAReview': RequestAReview,
};
